import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { H3, Tag, Card, Spinner, Callout } from "@blueprintjs/core";
import { Trans, withTranslation } from "react-i18next";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../utils/AuthenticatedFetch";
import { updateUser } from "../Home/Home";

var widgets = [];
localStorage.getItem("perm_home_customisation") === "true"
  ? (widgets = [
      { id: "0", content: <Trans>counters</Trans> },
      { id: "1", content: <Trans>evolution de la recette totale</Trans> },
      { id: "2", content: <Trans>key values</Trans> },
      { id: "3", content: <Trans>prensentaion of the product line</Trans> },
    ])
  : (widgets = [
      { id: "3", content: <Trans>prensentaion of the product line</Trans> },
    ]);

function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

function move(source, destination, droppableSource, droppableDestination) {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);
  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;
  return result;
}

const GRID = 2;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the selected look a bit nicer
  userSelect: "none",
  padding: GRID * 2,
  margin: `0 0 ${GRID}px 0`,
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "white",
  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: GRID,
  margin: "4px",
  minHeight: "80%",
});

class FavoriteSelector extends Component {
  constructor() {
    super();
    this.state = {
      selected: [],
      remaining: [],
    };
    this.id2List = {
      favorites: "selected",
      leftChoices: "remaining",
    };
  }

  componentDidMount() {
    const s = [];
    const r = [];
    authenticatedGetFetch("/fav", (res) => {
      for (const w of widgets) {
        if (res.includes(parseInt(w.id))) s.push(w);
        else r.push(w);
      }
      this.setState({ selected: s, remaining: r });
    });
  }

  getList = (id) => this.state[this.id2List[id]];

  sendChoiceToServer(choices) {
    this.setState({ loading: true });
    authenticatedPostFetch("/fav", { favs: choices }, () => {
      this.setState({ loading: false });
      if (updateUser !== undefined) updateUser();
    });
  }

  onDragEnd = (result) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) return;

    // dropped on the same area, only the order changed
    if (source.droppableId === destination.droppableId) {
      const selected = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { selected };

      if (source.droppableId === "leftChoices") state = { remaining: selected };

      this.setState(state);
      this.sendChoiceToServer(selected);
    } else {
      // dropped on the other area
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );

      this.setState({
        selected: result.favorites,
        remaining: result.leftChoices,
      });
      this.sendChoiceToServer(result.favorites);
    }
  };

  render() {
    return (
      <Callout title={<Trans>my home page</Trans>} icon="home">
        <Card>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <div className="flexbox-center" style={{ marginBottom: 15 }}>
              <div>
                <H3>
                  <Trans>my home page</Trans>
                </H3>
                <Droppable droppableId="favorites">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {this.state.selected.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {
                                <Tag fill={true} large={true}>
                                  {item.content}
                                </Tag>
                              }
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
              <div>
                <H3>
                  <Trans>available widgets</Trans>
                </H3>
                <Droppable droppableId="leftChoices">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {this.state.remaining.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {<Tag large={true}>{item.content}</Tag>}
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </div>
          </DragDropContext>
          {this.state.loading ? (
            <Callout intent="warning">
              <div className="flexbox-left">
                <Spinner size={20} />
                <Trans>syncronizing data with the server</Trans>
              </div>
            </Callout>
          ) : (
            <Callout intent="success">
              <Trans>data are syncronized with the server</Trans>
            </Callout>
          )}
        </Card>
      </Callout>
    );
  }
}

export default withTranslation()(FavoriteSelector);
